import { render } from "./SlideFadeTransition.vue?vue&type=template&id=6c52b2e3&scoped=true"
const script = {}

import "./SlideFadeTransition.vue?vue&type=style&index=0&id=6c52b2e3&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c52b2e3"]])

export default __exports__